// removed by extract-text-webpack-plugin
module.exports = {"book":"book_2pQad","inner":"inner_245AP","new":"new_PsSsO","existing":"existing_1mIt_","name":"name_2TJcy","books":"books_18gFX","action":"action_2JxEu","submit":"submit_1S3um","tryOut":"tryOut_3Xts6","notLoggedIn":"notLoggedIn_aFUMl"};


//////////////////
// WEBPACK FOOTER
// ./app/components/my-orders/styles.scss
// module id = 479
// module chunks = 1